export function sortByDistance(storeA, storeB) {
    if (!(storeA.distance && storeB.distance))
        return 0;
    if (storeA.distance < storeB.distance)
        return -1;
    if (storeA.distance > storeB.distance)
        return 1;
    return 0;
}
